import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessProjectOnboadingScreens } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canManageProjectManagement } from "@/helpers/permissions";

import { OnboardingScreenOverviewPage } from "./pages/list/OnboardingScreenOverviewPage";
import { CreateOnboardingScreenPage } from "./pages/onboarding-screen-editor/CreateOnboardingScreenPage";
import { EditOnboardingScreenPage } from "./pages/onboarding-screen-editor/EditOnboardingScreenPage";
import { onboardingScreensRoutes } from "./routes";

export const onboardingScreensRoute = [
  {
    path: onboardingScreensRoutes.list,
    element: (
      <RequireAuth permission={canAccessProjectOnboadingScreens}>
        <OnboardingScreenOverviewPage />
      </RequireAuth>
    ),
  },
  {
    path: onboardingScreensRoutes.new,
    element: (
      <RequireAuth permission={canManageProjectManagement}>
        <CreateOnboardingScreenPage />
      </RequireAuth>
    ),
  },
  {
    path: onboardingScreensRoutes.edit,
    element: (
      <RequireAuth permission={canManageProjectManagement}>
        <EditOnboardingScreenPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
